module.exports = __webpack_public_path__ + "static/media/20191214_160630.41071dc1.jpg";